import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import axios from 'axios';
import Modal from 'react-modal';
import { Button, Checkbox, Grid, makeStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import InputBase from '@material-ui/core/InputBase';
import { CommonConfig } from '../../../../config/common-config';
import LoaderPopUp from '../../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../../components/loaderpopup/success';
import ErrorPopUp from '../../../../components/loaderpopup/error';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        alignItems: 'center',
        width: 400,
    },

    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        width: '250px',
        fontSize: '12px',
        fontFamily: 'Rubik',
    },
    iconButton: {
        padding: 10,
    },
    addButton: {
        width: '120px',
        height: '40px',
        textTransform: 'capitalize',
        fontWeight: '400 !important',
    },
    errorMsg: {
        marginLeft: '10px',
        color: '#fd5f5f',
        fontSize: '11px',
    },
    noRecord: {
        display: 'flex',
        justifyContent: 'center',
        '& h1': {
            alignSelf: 'center',
            color: 'grey',
            fontFamily: 'Rubik',
            fontSize: '14px',
            fontWeight: '400',
        },
    },
}));

const customStyles = {
    overlay: {
        backgroundColor: 'rgba(119, 119, 119, 0.3)',
        zIndex: '9999',
        // position: 'absolute !important'
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '50%',
        padding: '0px',
        borderRadius: '10px',
        border: 'none',
        maxHeight: '90%',
    },
};

Modal.setAppElement('#root');

function MyModal(props) {
    const PropsContent = props.itecUsers.data && props.itecUsers.data.content;
    const [data, setData] = useState(PropsContent);
    const [select, setSelect] = useState([]);
    const [selectError, setselectError] = useState({ set: false, message: '' });
    const [oldDAjson, setOldDAjson] = useState([]);
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const tennantDetails = useSelector((state) => state.loginsuccessreducer.tennantName.tennantName);
    const serviceIdSelected = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const history = useHistory();
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [noRecords, setNoRecords] = useState(false);
    const [reRender, setreRender] = React.useState(true);

    const addUser = (user, event) => {
        if (event.target.checked) {
            user.selected = true;
            setSelect([
                ...select,
                {
                    employeeId: user.itecEmpId,
                    employeeFirstName: user.firstName,
                    employeeLastName: user.lastName,
                    employeeEmailId: user.officeEmail,
                },
            ]);
        } else {
            const arr = select.filter((u) => {
                if (u.employeeId != user.itecEmpId) return u;
            });
            user.selected = false;
            setSelect(arr);
        }
    };

    const close = () => {
        setSearchQuery('');
        const arr =
            data &&
            data.filter((u) => {
                u.selected = false;
                return u;
            });
        setData(arr);
        setSelect([]);
        props.handleCloseDialog();
        getOldDatas();
    };

    const search = (event) => {
        setSearchQuery(event.target.value);
        if (event.target.value == '') {
            setSearchQuery(false);
            setData(PropsContent);
            setNoRecords(false);
        } else if (event.target.value.length > 2) {
            let re = new RegExp(event.target.value + '', 'i');
            let result =
                data &&
                data.filter(function (e) {
                    return e.firstName.search(re) != -1;
                });
            if (result && result.length) {
                setData(result);
                setNoRecords(false);
            } else {
                setNoRecords(true);
            }
        } else {
            setData(PropsContent);
            // setSearchQuery(event.target.value);
        }
    };

    const clearField = () => {
        setSearchQuery('');
        setData([]);
        // setSearchData([]);
    };

    const submit = () => {
        close();
        setShowLoader(true);
        if (select.length > 0) {
            setShowLoader(true);
            setselectError({ set: true, message: '' });
            setOldDAjson((prev) => ({ ...prev, assigedUsers: [...select] }));

            setOldDAjson((prev) => {
                const axiosConfig = {
                    headers: {
                        'Content-Type': 'application/json;charset=UTF-8',
                        Authorization: bearerToken,
                    },
                };
                const assignedData = JSON.stringify({
                    serviceId: serviceIdSelected,
                    detailedAnalysisJson: { ...prev },
                    remarks: 'Remarks',
                });

                console.log('assignedData', assignedData);

                axios
                    .put(`${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/assign-user/${imcNameSelected}`, assignedData, axiosConfig)
                    .then((response) => {
                        if (response.status === 200) {
                            setShowLoader(false);
                            setSuccessPop(true);
                            props.handleCloseDialog();
                            setTimeout(() => {
                                setTimeout(() => {
                                    setSuccessPop(false);
                                    window.location.reload();
                                }, 3000);
                                setShowLoader(true);
                                // history.push('/menu/openservice');
                            }, 5000);
                        }
                    })
                    .catch((error) => {
                        const errResult = error.response;
                        if (errResult.data) {
                            setShowLoader(false);
                            setErrorPop(true);
                            setTimeout(() => {
                                setErrorPop(false);
                            }, 5000);
                            setErrorMsgGenerateRecceipt(errResult.data.message);
                        }
                    });
            });
        } else setselectError({ set: true, message: 'Please select at least one employee' });
    };
    const classes = useStyles();
    useEffect(() => {
        setData(PropsContent);
        getOldDatas();
    }, [serviceIdSelected, PropsContent, reRender, props]);

    const getOldDatas = () => {
        const axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                Authorization: bearerToken,
            },
        };
        axios
            .get(`${CommonConfig.dev.baseUrl1}/api/itr/detailed-analysis/by-serviceId/${imcNameSelected}/${serviceIdSelected}`, axiosConfig)
            .then((response) => setOldDAjson(response.data))
            .catch(() => { });
    };

    return (
        <div>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? <SuccessPopUp open={successpop} showSuccess={successpop} title="Assigned successfully" /> : null}

            <Modal isOpen={props.isOpen} style={customStyles} contentLabel="Example Modal">
                <div className="assign-team-popup">
                    <div>
                        <div align="end" style={{ marginRight: '20px', marginTop: '20px' }}>
                            <span
                                className="pop-close"
                                align="end"
                                onClick={() => {
                                    close();
                                }}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                            </span>
                        </div>
                        <div style={{ textAlign: 'center' }}>
                            <div className="main-title" style={{ fontSize: '18px', fontWeight: '500' }}>
                                Assign service to ITeC team
                            </div>
                            {/* <div className="sub-title" style={{ fontSize: '14px', color: '#BCBCBC' }}>
                                Select employee to the service
                            </div> */}
                        </div>
                    </div>
                    <div className="pop-search" style={{ border: '4px solid rgb(228 228 228)', margin: '2% 30%' }}>
                        <InputBase
                            className={classes.input}
                            placeholder="Select member to assign.."
                            inputProps={{ 'aria-label': 'search member to assign' }}
                            onChange={(event) => search(event)}
                        // clearField={clearField}
                        // onClick={() => clearField()}g
                        />
                    </div>
                    {searchQuery && searchQuery.length < 3 ? (
                        <div className={classes.errorMsg} style={{ margin: '-2% 0% 0% 30%', minHeight: '2%' }}>
                            Please enter more than 2 characters
                        </div>
                    ) : null}
                    <div className="pop-check-container" style={{ padding: '2%', maxHeight: '200px', overflow: 'auto' }}>
                        <div className="sub-title" style={{ fontSize: '14px', fontWeight: '500', marginLeft: '21px' }}>
                            Select employee to the service
                        </div>
                        {!noRecords ? (
                            <Grid container>
                                {data &&
                                    data.map((user) => {
                                        return (
                                            <Grid key={user.itecEmpId.toString()} item xs={12} sm={6}>
                                                <ul style={{ listStyle: 'none', padding: '0', margin: '0', fontSize: '13px' }}>
                                                    <li>
                                                        <Checkbox
                                                            key={user.itecEmpId.toString()}
                                                            checked={user.selected ? true : false}
                                                            onChange={(event) => addUser(user, event)}
                                                            color="primary"
                                                        />{' '}
                                                        {user.itecEmpId} - {user.firstName} {user.lastName}
                                                    </li>
                                                </ul>
                                            </Grid>
                                        );
                                    })}
                            </Grid>
                        ) : (
                                <div className={classes.noRecord}>
                                    <h1>No records to display</h1>
                                </div>
                            )}
                    </div>
                    <div className="pop-button" style={{ padding: '2% 5%' }}>
                        <Button variant="contained" color="primary" onClick={submit} className={classes.addButton}>
                            Assign
                        </Button>
                    </div>
                    <div className="pop-button" style={{ padding: '2%', textAlign: 'center', color: 'red' }}>
                        <b>{selectError.message}</b>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

export default MyModal;
